export const BANANA_VIEWBOX_WIDTH = 137.14;
export const BANANA_VIEWBOX_HEIGHT = 75.17;
export const BANANA_PROGRESS_GAUGE_VIEWBOX_DEFAULT = {
  x : 0,
  y : 0,
  w : BANANA_VIEWBOX_WIDTH,
  h : BANANA_VIEWBOX_HEIGHT,
};
export function number_or_default (pValue, pDefault)
  {
    if (typeof pValue === "function")
      {
        try { return number_or_default (pValue (), pDefault); }
        catch (e) { return pDefault; }
      }
    const tNumber = Number (pValue);
    return Number.isFinite (tNumber) ? tNumber : pDefault;
  }

export function clamp (pValue, pMin, pMax)
  {
    return Math.max (pMin, Math.min (pMax, pValue));
  }

export function banana_progress_from_questions (pGoodAnswers, pTotalQuestions)
  {
    const tTotal = Math.max (0, number_or_default (pTotalQuestions, 0));
    if (tTotal <= 0) return 0;
    const tGoodAnswers = clamp (number_or_default (pGoodAnswers, 0), 0, tTotal);
    return tGoodAnswers / tTotal;
  }

export function banana_progress_clip_width (pProgress)
  {
    const tProgress = clamp (number_or_default (pProgress, 0), 0, 1);
    return +(tProgress * BANANA_VIEWBOX_WIDTH).toFixed (3);
  }

export function progress_from_data (pData)
  {
    if (pData && pData.progress !== undefined)
      return clamp (number_or_default (pData.progress, 0), 0, 1);

    const tGood = first_defined (pData, ["bonnesReponses", "goodAnswers", "value", "score"]);
    const tTotal = first_defined (pData, ["totalQuestions", "questionsTotal", "total", "max"]);
    return banana_progress_from_questions (tGood, tTotal);
      }

export function first_defined (pData, pKeys)
  {
    if (!pData) return undefined;
    const tKey = pKeys.find ((pKey) => pData[pKey] !== undefined);
    return tKey ? pData[tKey] : undefined;
  }

export function interpolate (pA, pB, pRatio)
  {
    return pA + (pB - pA) * clamp (number_or_default (pRatio, 0), 0, 1);
  }

export function format_svg_number (pValue)
  {
    return (+pValue.toFixed (3)).toString ();
  }

export function normalise_viewbox (pViewBox)
  {
    const tViewBox = pViewBox || {};
    return {
      x : number_or_default (tViewBox.x, BANANA_PROGRESS_GAUGE_VIEWBOX_DEFAULT.x),
      y : number_or_default (tViewBox.y, BANANA_PROGRESS_GAUGE_VIEWBOX_DEFAULT.y),
      w : clamp (number_or_default (tViewBox.w, BANANA_PROGRESS_GAUGE_VIEWBOX_DEFAULT.w), BANANA_VIEWBOX_WIDTH / 50, BANANA_VIEWBOX_WIDTH * 50),
      h : clamp (number_or_default (tViewBox.h, BANANA_PROGRESS_GAUGE_VIEWBOX_DEFAULT.h), BANANA_VIEWBOX_HEIGHT / 50, BANANA_VIEWBOX_HEIGHT * 50),
    };
  }

export function source_viewbox_from_data (pData)
  {
    return normalise_viewbox (
      (pData && pData.sourceViewBox)
      || (pData && pData.config && pData.config.sourceViewBox)
      || BANANA_PROGRESS_GAUGE_VIEWBOX_DEFAULT
    );
  }

export function source_url_from_data (pData)
  {
    const tUrl = pData && (pData.sourceSvgUrl || (pData.config && pData.config.sourceSvgUrl));
    return typeof tUrl === "string" && tUrl.trim () ? tUrl.trim () : "";
  }

export function source_text_from_data (pData)
  {
    const tText = pData && (pData.sourceSvgText || (pData.config && pData.config.sourceSvgText));
    return typeof tText === "string" && tText.trim () ? tText : "";
  }

export function gauge_clip_viewbox_from_data (pData)
  {
    return (pData && pData.sourceViewBox)
      || (pData && pData.config && pData.config.sourceViewBox)
      || BANANA_PROGRESS_GAUGE_VIEWBOX_DEFAULT;
  }

export function format_viewbox (pViewBox)
  {
    const tViewBox = normalise_viewbox (pViewBox);
    return [
      format_svg_number (tViewBox.x),
      format_svg_number (tViewBox.y),
      format_svg_number (tViewBox.w),
      format_svg_number (tViewBox.h),
    ].join (" ");
  }

export function total_from_data (pData)
  {
    return Math.max (0, number_or_default (
      first_defined (pData, ["totalQuestions", "questionsTotal", "total", "max"]),
      0));
  }

export function good_answers_from_data (pData)
  {
    const tTotal = total_from_data (pData);
    const tGood = number_or_default (
      first_defined (pData, ["bonnesReponses", "goodAnswers", "value", "score"]),
      0
    );
    return clamp (tGood, 0, tTotal);
  }

